export default "__VITE_ASSET__aDgJvzqz__"